import type { GameModule } from './game-module.js';

/**
 * Registre des GameModules (spec §4).
 *
 * En V1 il est peuplé statiquement (`registry.register(magneticDuo)`) ; le
 * chargement dynamique viendra avec le 2ᵉ jeu. Le moteur ne référence jamais
 * un module en dur.
 */
export interface ModuleRegistry {
  register(module: GameModule): void;
  get(id: string): GameModule | undefined;
  /** Comme `get`, mais lève si le module est inconnu. */
  require(id: string): GameModule;
  list(): readonly GameModule[];
}

export class UnknownGameModuleError extends Error {
  constructor(id: string) {
    super(`GameModule inconnu : "${id}".`);
    this.name = 'UnknownGameModuleError';
  }
}

export function createModuleRegistry(initial: readonly GameModule[] = []): ModuleRegistry {
  const modules = new Map<string, GameModule>();

  const registry: ModuleRegistry = {
    register(module: GameModule): void {
      modules.set(module.id, module);
    },
    get(id: string): GameModule | undefined {
      return modules.get(id);
    },
    require(id: string): GameModule {
      const module = modules.get(id);
      if (!module) {
        throw new UnknownGameModuleError(id);
      }
      return module;
    },
    list(): readonly GameModule[] {
      return [...modules.values()];
    },
  };

  for (const module of initial) {
    registry.register(module);
  }
  return registry;
}
